/** Знак VIA DOMUM (арка). Колір — currentColor, тож тема перемикається сама. Джерело: brand/domum/domum-mark-*.svg */
export function DomumMark({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 80" className={className} aria-hidden="true" focusable="false">
      <path d="M12 74 V34 A20 20 0 0 1 52 34 V74" fill="none" stroke="currentColor" strokeWidth="3.6" strokeLinecap="square" />
      <path d="M4 74 H60" fill="none" stroke="currentColor" strokeWidth="3.6" />
      <path d="M32 74 V42" fill="none" stroke="currentColor" strokeWidth="2.4" />
      <circle cx="32" cy="33" r="3.4" fill="currentColor" />
    </svg>
  );
}
